// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__p32rX","info":"Note_info__2t11h","note":"Note_note___vXIR","actions":"Note_actions__2UuU_"};